import { render, staticRenderFns } from "./Scans.vue?vue&type=template&id=44d9664c&"
import script from "./Scans.vue?vue&type=script&lang=js&"
export * from "./Scans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports